import React, { useState } from "react";
import { FaVolumeMute, FaVolumeUp } from "react-icons/fa";

const ReadPageButton = () => {
  const [isReading, setIsReading] = useState(false);

  const handleToggleRead = () => {
    if (!isReading) {
      const text = document.body.innerText;
      const speech = new SpeechSynthesisUtterance(text);
      speech.lang = "en-US";

     
      speech.onend = () => {
        setIsReading(false);
      };

      window.speechSynthesis.speak(speech);
      setIsReading(true);
    } else {
      
      window.speechSynthesis.cancel();
      setIsReading(false);
    }
  };

  return (
    <button
      onClick={handleToggleRead}
      style={{
        fontSize: "2.5rem",
        padding: "0",
        position: "fixed",      
        bottom: "15px",         
        right: "20px",          
        zIndex: 1000,           
        borderRadius: "10%",    
        border: "none",
        cursor: "pointer",
        color: "#ca9e1bff",
        background: "transparent",
      }}
    >
      {isReading ? <FaVolumeMute /> : <FaVolumeUp />}
    </button>
  );
};

export default ReadPageButton;